// extracted by mini-css-extract-plugin
export default {"header":"Navigation_header__R0NDv","background":"Navigation_background__PKL-v","list":"Navigation_list__c9CEB","active":"Navigation_active__HjESR"};